import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, subtitle, description }) => (
  <S.Content>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <Text as='h2' color='primary' family='heading'>
          {subtitle}
        </Text>
        <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
          {title}
        </Text>

        {description && <Text color='weak'>{description}</Text>}
      </Col>
    </Row>
  </S.Content>
)
